import React, {Component} from "react";
import styled from "styled-components";
import bgImg from "../Images/active6.jpg";
import {
  InfoParagraph,
  SmallMargin,
  SmallTitle,
  Line,
  SplashTitle,
  grayText,
  Marked
} from "../Tools/Variables";

const Wrapper = styled.div `
  position: relative;
  width: 90vw;
  max-width: 1200px;
  min-height: 80vw;
  max-height: 960px;
  background: url(${bgImg});
  background-size: cover;
  background-position: top;
  flex-direction: column;
  display: flex;
  text-align: right;
  color: white;
  justify-content: space-between;
  @media screen and (max-width: 780px) {
    width: 100vw;
    min-height: 100vh;
  }
`;

const Overlay = styled.div `
  transition: 0.5s ease-in-out;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background: black;
  opacity: 0.4;
`;

const InfoWrapper = styled.div `
  position: relative;
  z-index: 1;
  width: 40%;
  color: white;
  text-align: left;
  margin-left: 4%;
  @media screen and (max-width: 780px) {
    width: 90%;
  }
`;

class Active extends Component {
  render() {
    return (
      <div style={{
        position: "relative"
      }}>
        <Wrapper>
          <Overlay/>
          <div/>
          <div>
            <SplashTitle
              style={{
              fontWeight: 400,
              marginRight: 20,
              position: "relative",
              zIndex: 1
            }}>
              <div>UTVILAD</div>
            </SplashTitle>

            <SmallMargin/>
            <SplashTitle
              style={{
              fontWeight: 400,
              marginRight: 20,
              position: "relative",
              zIndex: 1
            }}>
              <div>FÖR</div>
            </SplashTitle>
            <SmallMargin/>

            <SplashTitle
              style={{
              fontWeight: 400,
              marginRight: 20,
              position: "relative",
              zIndex: 1
            }}>
              <div>PRESTATION</div>
            </SplashTitle>
          </div>

          <InfoWrapper>
            <SmallTitle>
              <Marked
                style={{
                color: grayText,
                padding: "0 10px"
              }}>
                En aktiv säng för ett aktivt liv.
              </Marked>
            </SmallTitle>
            <SmallMargin/>
            <InfoParagraph
              style={{
              marginLeft: 30,
              marginBottom: 30
            }}>
              En natts dålig sömn kan stå dig dyrt. Påverka din prestation, kosta pengar och
              inverka på din hälsa. Oavsett om du är elitidrottare eller om ditt arbete varje
              dag kräver ett klart huvud. Välj en lyxig säng som skingrar den oron.
            </InfoParagraph>
          </InfoWrapper>
        </Wrapper>
        <div
          style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 30
        }}>
          <SmallTitle style={{
            marginRight: 10
          }}>
            Du är värd att vakna utsövd{" "}
          </SmallTitle>
          <Line style={{
            width: "10%"
          }}/>
        </div>
      </div>
    );
  }
}

export default Active;



// WEBPACK FOOTER //
// ./src/Home/Active.js